<div class="transport-column-editor">

  <ng-container *ngIf="!editMode">
    <div class="readonly-layout">

      <div class="readonly-columns">
        <div class="column-box" *ngFor="let item of configuredColumns">{{ item | translate
          :[columnsByKey.get(item) == null ? 'shared.transport-column-editor.invalid-column'
          :columnsByKey.get(item).dictionaryKey, translationService.language]}}</div>
      </div>
      <div>
        <button mat-icon-button (click)="startEditing()"><sc-icon iconClass="fa-edit"></sc-icon></button>
      </div>

    </div>
  </ng-container>

  <ng-container *ngIf="editMode">
    <div class="editor-layout">
      <div class="editor-column">
        <div class="header-layout">
          <div class="column-header">
            <div class="header-label">
              <sc-dictionary-label dictionaryKey="shared.transport-column-editor.configured-columns"></sc-dictionary-label>
            </div>
          </div>
        </div>
      </div>
      <div class="editor-column">
        <div class="header-layout">
          <div class="column-header">
            <div class="header-label">
              <sc-dictionary-label dictionaryKey="shared.transport-column-editor.available-columns"></sc-dictionary-label>
            </div>
            <button mat-icon-button (click)="endEditing()"><sc-icon iconClass="fa-times"></sc-icon></button>
          </div>
        </div>
      </div>
    </div>
    <div class="editor-layout lists">
      <div class="editor-column">
        <div cdkDropList #availableList="cdkDropList" [cdkDropListData]="configuredColumns"
          [cdkDropListConnectedTo]="[configuredList]" class="list" (cdkDropListDropped)="drop($event)">
          <div class="list-item-box" *ngFor="let item of configuredColumns" cdkDrag>{{ item | translate
            :[columnsByKey.get(item) == null ? 'shared.transport-column-editor.invalid-column'
            :columnsByKey.get(item).dictionaryKey, translationService.language]}}</div>
        </div>
      </div>
      <div class="editor-column">
        <div cdkDropList #configuredList="cdkDropList" [cdkDropListData]="availableColumns" cdkDropListSortingDisabled
          [cdkDropListConnectedTo]="[availableList]" class="list" (cdkDropListDropped)="dropToAvailableList($event)">
          <div class="list-item-box" *ngFor="let item of availableColumns" cdkDrag>{{ item | translate
            :[columnsByKey.get(item) == null ? 'shared.transport-column-editor.invalid-column'
            :columnsByKey.get(item).dictionaryKey, translationService.language]}}</div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
